export const HISTORY_DESCRIPTION_1 = "Старое здание института";
export const HISTORY_TEXT_1 = [
  {
    type: "paragraph",
    content:
      "Если заглянуть в прошлое, многое станет понятным. Тридцатые годы – время первых пятилеток, трудовых подвигов. Именно тогда на Урале для решения не столько научных, сколько практических, важных для данного региона задач и был создан кожно-венерологический институт местного значения, ставший в последствии республиканским.",
  },
];

export const HISTORY_DESCRIPTION_2 = "В начале славных дел";
export const HISTORY_TEXT_2 = [
  {
    type: "paragraph",
    content:
      "Уже в эти годы в институте царила особая атмосфера научного поиска, направленного на быстрое и качественное решение прикладных проблем, которых немало вставало перед страной.",
  },
  {
    type: "paragraph",
    content:
      "Научная тематика тех лет касалась наиболее важных в практическом отношении разделов дерматовенерологии:",
  },
  {
    type: "list",
    items: [
      "Социальная венерология",
      "Профессиональные заболевания кожи на крупнейших промышленных предприятиях (Уралмашзаводе, медеплавильном комбинате, Верх-Исетском заводе и т.п.), а также в угольной промышленности и сельском хозяйстве",
      "Грибковые заболевания кожи",
      "Лечение сифилиса, мягкого шанкра и гонореи",
    ],
  },
];

export const HISTORY_DESCRIPTION_3 = "Годы борьбы с болезнями";
export const HISTORY_TEXT_3 = [
  {
    type: "paragraph",
    content:
      "Военные годы стали жестоким испытанием для страны, резко возросла заболеваемость венерическими и заразными кожными болезнями. Нужно было немедленно принимать меры для того чтобы прекратить распространение эпидемии. Лучшие силы были задействованы для подготовки студентов-медиков, лучшие врачи консультировали больных, не прекращался научный поиск.",
  },
];

export const HISTORY_DESCRIPTION_4 = "50-годы";
export const HISTORY_TEXT_4 = [
  {
    type: "paragraph",
    content:
      "Диалектика развития любого отраслевого НИИ обусловлена не только потребностями общества и здравоохранения, но и личностью руководителя. В 50-е и 60-е годы его возглавляла Александра Васильевна Бахирева – основоположник и руководитель микологических исследований на Урале. Она сумела вырастить плеяду талантливых ученых, позволивших говорить об Уральской микологической школе и микологии как главном направлении деятельности института тех лет. Свердловский НИКВИ в те годы был единственным в стране институтом, постоянно издающим монотематические сборники научных работ «Вопросы микологии», в которых находили отражение не только результаты научных исследований, но и рекомендации для практического здравоохранения.",
  },
  {
    type: "paragraph",
    content:
      "При активном участии Александры Васильевны в Свердловской области одной из первых в нашей стране было проведено широкое оснащение кожно-венерологических учреждений люминесцентными установками, внедрен метод массовых профилактических осмотров на дерматомикозы.",
  },
  {
    type: "paragraph",
    content:
      "С 1955 г . приказом Минздрава РСФСР Свердловский Облвенинститут включен в состав учреждений республиканского подчинения с наименованием Свердловский научно-исследовательский кожно-венерологический институт.",
  },
];

export const HISTORY_DESCRIPTION_5 = "60-е";
export const HISTORY_TEXT_5 = [
  {
    type: "paragraph",
    content:
      "Под руководством А.В.Бахиревой СКВИ превратился в научно-организационный методический центр дерматовенерологов 22 областей, краев и автономных республик Урала, Сибири и Дальнего Востока.",
  },
  {
    type: "paragraph",
    content:
      "Вторым направлением научных исследований института на протяжении четверти века являлось изучение профессиональных заболеваний кожи, занимающих до 20% от всех профессиональных заболеваний рабочих на Среднем Урале.",
  },
];

export const HISTORY_DESCRIPTION_6 = "70-е";
export const HISTORY_TEXT_6 = [
  {
    type: "paragraph",
    content:
      "Вспышка венерических заболеваний в начале 70-х годов привела к смене научной тематики. Новый директор – Яков Александрович Халемин, который немало сделал для профилактики профессиональной патологии кожи на коксохимическом производстве, становится организатором работ  по предотвращению распространения вензаболеваний в районах «строек века», в частности на БАМе. Эта задача была успешно решена.",
  },
];

export const HISTORY_DESCRIPTION_7 = "Ставка на молодых";
export const HISTORY_TEXT_7 = [
  {
    type: "paragraph",
    content:
      "По рекомендациям института совершенствовалась структура дерматовенерологической помощи и проводились профилактические мероприятия. Свои научные исследования институт широко комплексировал с учреждениями Минздрава СССР, РСФСР, Уральского научного центра АН СССР, кафедрами медицинских ВУЗов страны, органами практического здравоохранения Свердловской области и территорий Урала, Сибири и Дальнего Востока. Осуществляются выезды бригад научных сотрудников в курируемые территории.  Большое внимание уделяется подготовке высококвалифицированных кадров. Ведется активная издательская деятельность. С 1968 по 1981 гг. институтом изданы 12 сборников научных работ, монография, 2 учебных пособия, 2 книги для населения.",
  },
];

export const HISTORY_DESCRIPTION_8 = "Незабываемые годы";
export const HISTORY_TEXT_8 = [
  {
    type: "paragraph",
    content:
      "Именно Яков Александрович первым выразил серьезную озабоченность и тревогу в связи с таким Российским явлением как депопуляция, которая являлась следствием в том числе и возросшей заболеваемости инфекциями передаваемыми половым путем молодежи и подростков. Он много занимался изучением этого вопроса, порой не всегда находил понимание, но насколько он был прав показала жизнь.",
  },
];

export const HISTORY_DESCRIPTION_9 = "80-е";
export const HISTORY_TEXT_9 = [
  {
    type: "paragraph",
    content:
      "В 80-е годы в НИИ сформировалось новое научное направление – детская аллергодерматология. Нина Петровна Торопова – заместитель директора по научной работе – сумела не только создать научную школу и воспитать талантливых учеников, но объединить творческие усилия дерматологов, педиатров, аллергологов. Это содружество успешно продолжается и в наше время. А научные исследования в этом направлении развиваются, результаты их находят живой отклик и в России, и за рубежом - теперь уже в третьем поколении врачей и ученых.",
  },
];

export const HISTORY_DESCRIPTION_10 = "Карта";
export const HISTORY_TEXT_10 = [
  {
    type: "paragraph",
    content:
      "Наряду с научной деятельностью проводилась большая организационная работа в России по внедрению эффективных методов диспансеризации детей и подростков, новых подходов к терапии. В течение 14 лет профессор Н.П.Торопова была главным детским дерматологом Минздрава РСФСР. За эти годы проводилась активная работа по обучению врачей по проблемам детской дерматологии на базе СНИКВИ и УрНИИДВИ. Проведено более 50  выездных циклов, семинаров и конференций для дерматологов и педиатров.",
  },
];

export const HISTORY_DESCRIPTION_11 = "Научные успехи талантливой молодежи";
export const HISTORY_TEXT_11 = [
  {
    type: "paragraph",
    content:
      "Вторая половина 80-х годов ознаменовалась научными успехами талантливой молодежи, которая разрабатывала проблемы профессиональной патологии кожи, грибковых заболеваний, атопического дерматита, медико-социальных аспектов сифилиса  и тогда нового направления – внутриклеточных ИППП. В 1987 г. докторскую диссертацию по проблеме ихтиоза защитил В.Т.Куклин.",
  },
];

export const HISTORY_DESCRIPTION_12 = "Начало 90-х";
export const HISTORY_TEXT_12 = [
  {
    type: "paragraph",
    content:
      "Начало 90-х годов было ознаменовано общим кризисом научных исследований. Во всей стране редким событием стали защиты диссертаций, сократилось число научных публикаций. Но и в эти годы научная жизнь не замерла в институте. Была защищена докторская диссертация Е.А.Банникова «Аллергические дерматозы химической этиологии и микозы стоп у рабочих промышленных предприятий», кандидатские диссертации Т.Н.Барановской «Фолликулярный дискератоз Дарье», Н.М.Герасимовой «Роль метаболической и экскреторной функции печени в патогенезе экземы, нейродермита и экспериментального аллергического дерматита», М.А.Захаровым «Показатели перекисного окисления липидов у детей, больных экземой и нейродермитом, как основание применения антиоксидантной терапии», Н.Н.Филимонковой «Обоснование терапии больных псориазом с учетом функционального состояния гепатобилиарной системы», Р.Ф.Батыршиным  «Совершенствование организационных форм активного выявления больных сифилисом», А.А.Ярвиц «Метаболические изменения и их коррекция у больных красным плоским лишаем». Однако, многие научные разработки оставались незавершенными, так как резко сократилось финансирование. Неизбежный отток кадров поразил многие НИИ. Но только не этот. Перед институтом стояла перспектива после 18 лет строительства, начатого Я.А.Халеминым, обрести новые стены, а значит и новые возможности.",
  },
];

export const HISTORY_DESCRIPTION_13 = "Новые стены - новые возможности";
export const HISTORY_TEXT_13 = [
  {
    type: "paragraph",
    content:
      "Это свершилось в 1994 году. Такое долгожданное, прекрасное новое здание ждало современного оснащения и работоспособного коллектива. Фронтон здания венчает мемориальная доска памяти Я.А.Халемина, под руководством которого институт был спроектирован, построен и сдан в эксплуатацию.",
  },
  {
    type: "paragraph",
    content:
      "Реформы 90-х.  Время востребовало новое мышление, новый стиль работы, новой формации руководителей - молодых, энергичных, способных ориентироваться не только в вопросах организации научных исследований, но обладающих запасом экономических и юридических знаний и умело их использующих.",
  },
];

export const HISTORY_DESCRIPTION_14 = "Конец 90-х";
export const HISTORY_TEXT_14 = [
  {
    type: "paragraph",
    content:
      "С конца 90-х годов бразды правления коллективом находятся в руках, можно сказать потомственного дерматовенеролога, который за свои 40 с небольшим лет прошел все ступени роста в институте – от врача ординатора до директора. Это Николай Васильевич Кунгуров – доктор медицинских наук, профессор, заслуженный врач России. Он дал мощный заряд для восстановления приостановленных из-за нехватки средств перспективных научных исследований, а также для развития новых приоритетных направлений дерматовенерологии и иммунопатологии.",
  },
  {
    type: "paragraph",
    content:
      "Практически одновременно с ним начала свою деятельность на посту заместителя директора по научной работе Герасимова Нина Михайловна, которая тоже прошла в институте путь от медицинского статистика до профессора.",
  },
];

export const HISTORY_DESCRIPTION_15 = "Планирование научной тематики";
export const HISTORY_TEXT_15 = [
  {
    type: "paragraph",
    content:
      "Планирование научно тематики всегда было самой ответственной и кропотливой работой. Научные мысли, способные воплотиться в эффективные результаты должны обсуждаться и координироваться с коллегами-учеными. Только серьезная и продолжительная работа научных коллективов способна дать плоды и быть востребована в практике.",
  },
];

export const HISTORY_DESCRIPTION_16 = "Атопический дерматит";
export const HISTORY_TEXT_16 = [
  {
    type: "paragraph",
    content:
      "Многолетние исследования патогенеза атопического дерматита и апробация новых методов лечения доказали необходимость дифференциации этого заболевания для целенаправленной терапии. Результаты исследований по этой проблеме легли в основу докторской диссертации Николая Васильевича и кандидатских диссертаций его учеников, опубликованы в монографии «Атопический дерматит. Типы течения, принципы терапии», в которой на основании предшествующего опыта, собственных наработок и перспективных исследований прослеживается связь поколений Уральской  школы.",
  },
];

export const HISTORY_DESCRIPTION_17 = "Дерматоонкология";
export const HISTORY_TEXT_17 = [
  {
    type: "paragraph",
    content:
      "Именно в эти годы завершились исследования по проблеме ранней профилактики злокачественных новообразований кожи. Идеи докторской диссертации Н.М.Малишевской нашли достойное продолжение в работах ее учеников. Были широко представлены для внедрения.",
  },
];

export const HISTORY_DESCRIPTION_18 = "Урогенитальная хламидийная инфекция";
export const HISTORY_TEXT_18 = [
  {
    type: "paragraph",
    content:
      "Научные разработки по проблеме урогенитальной хламидийной инфекции, создание оригинальных диагностических и лечебно-реабилитационных программ позволили институту встать в ряд виднейших научных коллективов не только в России, но и за рубежом. Методические рекомендации и пособия для врачей широко внедрены во всех уголках России.",
  },
];

export const HISTORY_DESCRIPTION_19 = "Новое тысячелетие";
export const HISTORY_TEXT_19 = [
  {
    type: "paragraph",
    content:
      "Двухтысячный год ознаменовался прорывом в исследованиях как по традиционным, так и по новым научным направлениям. Время требовало внимания к разработке новых организационных технологий на основе новых экономических реалий и новых методов программированного анализа. Чрезвычайно актуальными явились вопросы патогенеза, лечения и профилактики  вирусных инфекций, передаваемых половым путем. Эти исследования были включены в отраслевую научно-исследовательскую программу на 2001-2005 гг. В институте выросли молодые кадры высшей квалификации.",
  },
];

export const HISTORY_DESCRIPTION_20 = "Проблема псориатической болезни";
export const HISTORY_TEXT_20 = [
  {
    type: "paragraph",
    content:
      "Новый взгляд на иммунопатологические аспекты патогенеза псориаза, осмысление с новых позиций иммунотерапии этого дерматоза явились результатом многолетних исследований и поисков эффективной терапии заболевания. Идеи докторской диссертации Н.Н.Филимонковой нашли продолжение в работах ее учеников. Все они сотрудники института.",
  },
];

export const HISTORY_DESCRIPTION_21 = "Проблема диагностики и лечения";
export const HISTORY_TEXT_21 = [
  {
    type: "paragraph",
    content:
      "Результаты изучения фундаментальных и клинических аспектов патогенеза лимфом кожи, проводимого в кооперации с исследовательскими центрами РАМН и ведущими дерматологическими клиниками Европы и Америки, изложены в докторской диссертации М.М.Кохан и ее талантливого ученика И.А.Куклина.",
  },
];

export const HISTORY_DESCRIPTION_22 = "Проблема микозов ногтей";
export const HISTORY_TEXT_22 = [
  {
    type: "paragraph",
    content:
      "Не были забыты и традиционные микологические исследования. Обнаружены интересные особенности течения микозов стоп, онихомикозов у рабочих горнодобывающей промышленности и метростроителей, а также у пациентов с патологией сосудов нижних конечностей. С учетом результатов исследований разработаны программы дифференциальной диагностики  и терапии, изложенные в кандидатских диссертациях и пособиях для врачей.",
  },
];

export const HISTORY_DESCRIPTION_23 = "Экономические и правовые аспекты";
export const HISTORY_TEXT_23 = [
  {
    type: "paragraph",
    content:
      "Экономические и правовые аспекты организации работы КВУ – новое направление, разрабатываемое под руководством Н.В.Кунгурова, уже имеет ряд последователей, развивающих его научные идеи, результаты которых получили широкий отклик в практическом здравоохранении и были высоко оценены руководством отрасли.",
  },
];

export const HISTORY_DESCRIPTION_24 =
  "Содружество с акушерами-гинекологами и педиатрами";
export const HISTORY_TEXT_24 = [
  {
    type: "paragraph",
    content:
      "Совместные исследования в тесном содружестве с акушерами-гинекологами и педиатрами вылились в интереснейшие новые данные об особенностях профилактики врожденного сифилиса и комплексные программы взаимодействия и этапности ведения беременных, больных сифилисом и новорожденных от больных матерей. На основании совместных работ в области инфекций, передаваемых половым путем разработаны  методические материалы и пособия для врачей, апробированы новые технологии диагностики и лечения, защищенные патентами Российской Федерации.",
  },
];

export const HISTORY_DESCRIPTION_25 = "Исследования в области эпидемиологии";
export const HISTORY_TEXT_25 = [
  {
    type: "paragraph",
    content:
      "Продолжались также исследования в области эпидемиологии и организации борьбы с распространением инфекций, передаваемых половым путем, в частности сифилиса. Многие аспекты профилактической работы в группах риска, новые формы и методы контроля за ИППП, новые закономерности нынешней эпидемии вензаболеваний отражены в диссертационных исследованиях и методических материалах Т.А.Сырневой и ее учеников.",
  },
  {
    type: "paragraph",
    content:
      "Изучение эпидемиологии и многолетней динамики заболеваемости скрытым сифилисом в регионах Урала, Сибири и Дальнего Востока, курируемых институтом, выявило ряд неизвестных ранее закономерностей, которые необходимо учитывать при проведении профилактической работы (В.И.Сурганова, 1998).",
  },
];

export const HISTORY_DESCRIPTION_26 =
  "Лабораторные исследования - основа науки";
export const HISTORY_TEXT_26 = [
  {
    type: "paragraph",
    content:
      "Лабораторные исследования в институте всегда были во главе научных открытий, продолжается эта традиция и в наши дни. Сотрудниками лабораторного отдела защищаются  диссертации, патенты, технологии, методические рекомендации.",
  },
];

export const HISTORY_DESCRIPTION_27 = "Вирусные и вирус";
export const HISTORY_TEXT_27 = [
  {
    type: "paragraph",
    content:
      "Одним из новых направлений является изучение эпидемиологии, этиологии, патогенеза, роли в онкопатологии, возможностей лабораторной диагностики и эффективной терапии вирусных ИППП (герпесвирусная, папилломавирусная инфекция, взаимовлияние сифилиса и парентеральных гепатитов). Результаты завершенных диссертационных исследований, новые  методы диагностики и лечения широко внедряются в практику.",
  },
];

export const HISTORY_DESCRIPTION_28 = "Клиника высоких технологий";
export const HISTORY_TEXT_28 = [
  {
    type: "paragraph",
    content:
      "Ежегодно в клинике УрНИИДВИ проходят лечение от 2200 до 2700 больных – взрослых и детей.  С 2006 г. клиника Урниидви входит в число федеральных высокотехнологичных клиник.",
  },
];

export const HISTORY_DESCRIPTION_29 = "Все условия для качественного лечения";
export const HISTORY_TEXT_29 = [
  {
    type: "paragraph",
    content:
      "Лечиться в комфортных условиях намного приятней, а значит выздоровление придет быстрее.",
  },
];

export const HISTORY_DESCRIPTION_30 = "УрНИИДВИ";
export const HISTORY_TEXT_30 = [
  {
    type: "paragraph",
    content:
      "На протяжении всех лет своей деятельности в институте активно ведется последипломная подготовка врачей дерматовенерологов для различных регионов Российской Федерации.",
  },
];

export const HISTORY_DESCRIPTION_31 = "Выезды в курируемые территории";
export const HISTORY_TEXT_31 = [
  {
    type: "paragraph",
    content: "Как и прежде продолжаются выезды в курируемые территории.",
  },
];
